import { useRef } from 'react';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../../hook.task-breakpoints.js';
import { DraggableTile } from '../tile/atom.draggable.js';
import { OnImageTile } from '../tile/atom.tile.js';
import { tokens, dropzone, dropzoneTile } from './atom.with-tile.style.js';
import { useDownscaledTileContent } from './hook.downscale-tile.js';
import { jsx } from 'react/jsx-runtime';

function DropzoneWithTile(props) {
  const tileRef = useRef(null);
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const ratio = isMobile ? 0.025 : 0.05;
  useDownscaledTileContent(props.dropzoneRef, tileRef);
  const dropzoneHeight = props.dropzone.placement.height * props.scale;
  const dropzoneWidth = props.dropzone.placement.width * props.scale;
  return /*#__PURE__*/jsx("div", {
    ref: props.setNodeRef,
    className: dropzone,
    "data-over": props.isOver,
    "data-transparent": !props.settings.visibleDropzones,
    style: tokens.__override({
      top: `${props.dropzone.placement.y * 100}%`,
      left: `${props.dropzone.placement.x * 100}%`,
      width: `${dropzoneWidth}px`,
      height: `${dropzoneHeight}px`,
      padding: `${Math.min(8, dropzoneHeight * ratio, dropzoneWidth * ratio) + 2}px`
    }),
    children: /*#__PURE__*/jsx("div", {
      ref: tileRef,
      className: dropzoneTile,
      children: props.draggable ? /*#__PURE__*/jsx(DraggableTile, {
        ...props.tileProps,
        isDraggingItem: props.isDraggingTileWithin,
        preferredFlow: dropzoneHeight <= 90 && props.tileProps.tile.type === "Audio" ? "row" : undefined
      }) : /*#__PURE__*/jsx(OnImageTile, {
        ...props.tileProps,
        preferredFlow: dropzoneHeight <= 90 && props.tileProps.tile.type === "Audio" ? "row" : undefined
      })
    })
  });
}

export { DropzoneWithTile };
//# sourceMappingURL=atom.with-tile.js.map
